var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showEmailValidation || !!_vm.emailValidationInModal
        ? [
            _vm.form
              ? _c(
                  "form",
                  {
                    staticClass: "registration-form",
                    attrs: { action: _vm.action, method: "POST" }
                  },
                  [
                    _c("input", {
                      attrs: { type: "hidden", name: "_token" },
                      domProps: { value: _vm.csrkToken }
                    }),
                    _vm._v(" "),
                    _c(
                      "md-card",
                      { staticClass: "profil-form" },
                      [
                        _c("md-card-header", [
                          _c("h2", {
                            staticClass:
                              "md-title md-title-dark page-sub-title !text-lg",
                            domProps: { innerHTML: _vm._s(_vm.title) }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-card-content",
                          [
                            _c(
                              "transition",
                              { attrs: { name: "slide-y-top" } },
                              [
                                _c("div", [
                                  !_vm.hideEntityType
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "entity-type-container",
                                          class: {
                                            "md-invalid": !!_vm.errors
                                              .entity_type
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "!text-sm" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.entityTypeSelectionLabel
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("entity-type-input", {
                                            attrs: {
                                              dusk: "entity-type-input"
                                            },
                                            model: {
                                              value: _vm.fData.entity_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fData,
                                                  "entity_type",
                                                  $$v
                                                )
                                              },
                                              expression: "fData.entity_type"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.errors.entity_type
                                            ? _c(
                                                "span",
                                                { staticClass: "md-error" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.entity_type
                                                        ? _vm.errors
                                                            .entity_type[0]
                                                        : ""
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.fData.entity_type == "company"
                                    ? _c(
                                        "div",
                                        { staticClass: "form-row mb-2" },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              "input-name": "entity_name",
                                              disabled: _vm.submitting
                                                ? "disabled"
                                                : null,
                                              dusk: "entity-name-input",
                                              required: "",
                                              placeholder: _vm.$t(
                                                "registration.entity-name"
                                              ),
                                              "has-error": !!_vm.errors
                                                .entity_name,
                                              error: _vm.errors.entity_name
                                                ? _vm.errors.entity_name[0]
                                                : "",
                                              "prepend-icon": "building"
                                            },
                                            model: {
                                              value: _vm.fData.entity_name,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fData,
                                                  "entity_name",
                                                  $$v
                                                )
                                              },
                                              expression: "fData.entity_name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-row mb-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col mb-2 md:mb-0 md:mr-1"
                                      },
                                      [
                                        _c("FormInput", {
                                          attrs: {
                                            "input-name": "lastname",
                                            disabled: _vm.submitting
                                              ? "disabled"
                                              : null,
                                            required: "",
                                            placeholder: _vm.$t(
                                              "registration.lastname"
                                            ),
                                            "has-error": !!_vm.errors.lastname,
                                            error: _vm.errors.lastname
                                              ? _vm.errors.lastname[0]
                                              : "",
                                            "prepend-icon": "user"
                                          },
                                          model: {
                                            value: _vm.fData.lastname,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.fData,
                                                "lastname",
                                                $$v
                                              )
                                            },
                                            expression: "fData.lastname"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col md:ml-1" },
                                      [
                                        _c("FormInput", {
                                          attrs: {
                                            "input-name": "firstname",
                                            disabled: _vm.submitting
                                              ? "disabled"
                                              : null,
                                            required: "",
                                            placeholder: _vm.$t(
                                              "registration.firstname"
                                            ),
                                            "has-error": !!_vm.errors.firstname,
                                            error: _vm.errors.firstname
                                              ? _vm.errors.firstname[0]
                                              : "",
                                            "prepend-icon": "user"
                                          },
                                          model: {
                                            value: _vm.fData.firstname,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.fData,
                                                "firstname",
                                                $$v
                                              )
                                            },
                                            expression: "fData.firstname"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row mb-2" },
                                    [
                                      _c("city-input", {
                                        attrs: {
                                          name: "city_id",
                                          label: _vm.$t(
                                            "registration.your-city"
                                          ),
                                          "no-label": true,
                                          "city-name": _vm.fData["city_name"],
                                          "input-error": _vm.errors["city_id"],
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null,
                                          dusk: "city-input",
                                          required: "",
                                          "new-version": "",
                                          icon: "city"
                                        },
                                        model: {
                                          value: _vm.fData["city_id"],
                                          callback: function($$v) {
                                            _vm.$set(_vm.fData, "city_id", $$v)
                                          },
                                          expression: "fData['city_id']"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row mb-2" },
                                    [
                                      _c("phone-field", {
                                        ref: "phoneInput",
                                        attrs: {
                                          name: "phone",
                                          errors: _vm.errors.mobile,
                                          label: _vm.$t("registration.mobile"),
                                          "mobile-only": "",
                                          "country-id": _vm.countryId,
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null,
                                          required: "",
                                          "new-version": ""
                                        },
                                        model: {
                                          value: _vm.fData.mobile,
                                          callback: function($$v) {
                                            _vm.$set(_vm.fData, "mobile", $$v)
                                          },
                                          expression: "fData.mobile"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.showEmailField
                                    ? _c(
                                        "div",
                                        { staticClass: "mb-2" },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              type: "email",
                                              "input-name": "email",
                                              disabled: _vm.submitting
                                                ? "disabled"
                                                : null,
                                              required: "",
                                              placeholder: _vm.$t(
                                                "registration.your-email"
                                              ),
                                              "has-error": !!_vm.errors.email,
                                              error: _vm.errors.email
                                                ? _vm.errors.email[0]
                                                : "",
                                              "prepend-icon": "at",
                                              dusk: "email-input"
                                            },
                                            model: {
                                              value: _vm.fData.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.fData,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "fData.email"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("FormInput", {
                                        attrs: {
                                          "input-type": "password",
                                          "input-name": "password",
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null,
                                          required: "",
                                          placeholder: _vm.$t(
                                            "registration.password"
                                          ),
                                          "has-error": !!_vm.errors.password,
                                          error: _vm.errors.password
                                            ? _vm.errors.password[0]
                                            : "",
                                          "prepend-icon": "lock",
                                          dusk: "password-input"
                                        },
                                        on: {
                                          focus: function($event) {
                                            _vm.passwordFieldFocused = true
                                            _vm.passwordFieldTouched = true
                                          },
                                          blur: function($event) {
                                            _vm.passwordFieldFocused = false
                                          }
                                        },
                                        model: {
                                          value: _vm.fData.password,
                                          callback: function($$v) {
                                            _vm.$set(_vm.fData, "password", $$v)
                                          },
                                          expression: "fData.password"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-2" }, [
                                    _c("div", { staticClass: "relative" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            style: { color: "#a0a0a0" },
                                            attrs: { icon: ["fas", "suitcase"] }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fData.yourNeed,
                                              expression: "fData.yourNeed"
                                            }
                                          ],
                                          staticClass:
                                            "block appearance-none bg-white border border-gray-200 text-sm rounded-md w-full h-[34px] p-1.5 ps-10 pe-9 focus:outline-none focus:border-primary-dark-50",
                                          class: {
                                            "italic !text-gray-400": !_vm.fData
                                              .yourNeed,
                                            "!text-primary-dark-50": !!_vm.fData
                                              .yourNeed,
                                            "border-red-500": !!_vm.errors
                                              .yourNeed
                                          },
                                          attrs: {
                                            name: "your-need",
                                            disabled: _vm.submitting,
                                            dusk: "your-need-input"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.fData,
                                                "yourNeed",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "registration.your-need"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.userNeeds, function(need) {
                                            return _c(
                                              "option",
                                              {
                                                key: "need_" + need.id,
                                                staticClass:
                                                  "not-italic text-primary-dark-50",
                                                domProps: { value: need.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(need.label) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none"
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "#a0a0a0",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: { d: "M6 9l6 6l6 -6" }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.errors.yourNeed
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "my-2 text-xs text-red-500"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.errors.yourNeed[0])
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mb-2" }, [
                                    _c("div", { staticClass: "relative" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none"
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            style: { color: "#a0a0a0" },
                                            attrs: { icon: ["fas", "bullhorn"] }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fData.know,
                                              expression: "fData.know"
                                            }
                                          ],
                                          staticClass:
                                            "block appearance-none bg-white border border-gray-200 text-sm rounded-md w-full h-[34px] p-1.5 ps-10 pe-9 focus:outline-none focus:border-primary-dark-50",
                                          class: {
                                            "italic !text-gray-400": !_vm.fData
                                              .know,
                                            "!text-primary-dark-50": !!_vm.fData
                                              .know,
                                            "border-red-500": !!_vm.errors.know
                                          },
                                          attrs: {
                                            name: "know",
                                            disabled: _vm.submitting,
                                            dusk: "know-input"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.fData,
                                                "know",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: { disabled: "" },
                                              domProps: { value: null }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "registration.find-way"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.findWay, function(know) {
                                            return _c(
                                              "option",
                                              {
                                                key: "know_" + know.id,
                                                staticClass:
                                                  "not-italic text-primary-dark-50",
                                                domProps: { value: know.id }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(know.label) +
                                                    "\n                                        "
                                                )
                                              ]
                                            )
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none"
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "#a0a0a0",
                                                "stroke-width": "2",
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "aria-hidden": "true"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: { d: "M6 9l6 6l6 -6" }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.errors.know
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "my-2 text-xs text-red-500"
                                          },
                                          [_vm._v(_vm._s(_vm.errors.know[0]))]
                                        )
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row form-row-submit" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "form-submit-button" },
                                        [
                                          _c("p", {
                                            staticClass: "accept-tos",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "registration.accept-tos"
                                                )
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("submit-button", {
                                            staticClass:
                                              "registration-standalone-button",
                                            attrs: {
                                              type: "submit",
                                              submitting: _vm.submitting,
                                              label: _vm.$t(
                                                "registration.create_account"
                                              ),
                                              dusk: "submit-profile-button"
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.onSubmit()
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-row form-row-already-member"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "#" },
                                          on: { click: _vm.login }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "registration.already-member-log-in"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("hr", {
                                    staticClass: "pilot-owner-separator"
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-row pilot-owner-links"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "/registration-other/pilot"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "registration.you-are-pilot"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "pilot-owner-divider" },
                                        [_vm._v("|")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "/registration-other/owner"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "registration.you-are-owner"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.showEmailValidation
        ? [
            _vm.emailValidationInModal
              ? _c("div", {
                  staticClass: "md-overlay md-fixed md-dialog-overlay"
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.emailValidationInModal
              ? _c(
                  "md-dialog",
                  {
                    attrs: {
                      "md-active": true,
                      "md-click-outside-to-close": false,
                      "md-close-on-esc": false
                    }
                  },
                  [
                    _c("email-validation", {
                      attrs: {
                        email: _vm.fData.email,
                        "return-location": _vm.returnLocation
                      }
                    })
                  ],
                  1
                )
              : _c("email-validation", {
                  attrs: {
                    email: _vm.fData.email,
                    "return-location": _vm.returnLocation
                  }
                })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07a2e519", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a2e519","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/form.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-07a2e519","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/form.vue
// module chunks = 1 2 3